// extracted by mini-css-extract-plugin
export default {"editEdge":"ViewHeatmapEdge_editEdge__GDD2g","field":"ViewHeatmapEdge_field__Zvp0F","buttons":"ViewHeatmapEdge_buttons__DW+Jm","deleteButton":"ViewHeatmapEdge_deleteButton__jfWtK"};